import { SHButton } from "@components/design-systems";
import { DownloadSVG } from "@components/svgs";
import { FeeExportDTO } from "@models/platform-analysis/entities/feeExport";
import { FeesDisplayStyle } from "@models/platform-analysis/enums/fee/displayStyle";
import { useTheme } from "@mui/material";
import { useCallback } from "react";
import { utils, writeFile } from "xlsx-js-style";
import { getWorksheetV2 } from "./utils";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { FeesPerformanceScope } from "@models/platform-analysis/enums/fee/feesPerformanceScope";
import { FeesDisplayMode } from "@models/platform-analysis/enums/fee/displayMode";

interface ExportExcelButtonProps {
  data?: FeeExportDTO;
  mode?: FeesDisplayStyle;
  isExcludePerformanceFees?: boolean;
  isSMATableDetailMode?: boolean;
  performanceScope?: FeesPerformanceScope;
  displayMode?: FeesDisplayMode;
  disabled?: boolean;
  isExcludeSubTotal?: boolean;
}
export const ExportExcelButton = ({
  data,
  mode = FeesDisplayStyle.Dollar,
  isExcludePerformanceFees = false,
  performanceScope = FeesPerformanceScope.Including,
  displayMode = FeesDisplayMode.Summary,
  disabled,
  isExcludeSubTotal = false,
}: ExportExcelButtonProps) => {
  const { palette } = useTheme();
  const isReview = useSelector(
    (state: RootState) => state.platformAnalysis?.platformAnalysis?.isReview,
  );

  const handleOnDownload = useCallback(() => {
    if (!data) return;
    const workbook = utils.book_new();
    const worksheet = getWorksheetV2(
      data,
      mode,
      isExcludePerformanceFees,
      isExcludeSubTotal,
      performanceScope,
      displayMode,
    );

    // Add the worksheet to the workbook
    utils.book_append_sheet(workbook, worksheet, "Analysis");
    // Save the workbook
    writeFile(
      workbook,
      `SuitabilityHub Fee ${isReview ? "Review" : "Analysis"} - ${
        data.name
      }.xlsx`,
    );
  }, [
    data,
    mode,
    isReview,
    isExcludePerformanceFees,
    isExcludeSubTotal,
    performanceScope,
    displayMode,
  ]);

  return (
    <SHButton
      onClick={handleOnDownload}
      startIcon={
        <DownloadSVG width={12} height={13} color={palette.text.primary} />
      }
      variant="outlined"
      disableRipple
      disabled={disabled || !data}
      sx={{
        "&:active svg path": {
          fill: palette.common.white,
        },
      }}
    >
      Excel
    </SHButton>
  );
};
